module.exports = __webpack_public_path__ + "static/media/12-5.4f0ca57a.mp3";